<div class="confirmation-dialog-container">
  <div class="confirmation-content">

    <div class="share-icon">
      <div class="icon-circle" >
        <i class="bi bi-share" style="color: #026bc1; font-size: 24px;"></i>
      </div>
    </div>
    
    <!-- Dynamic Confirmation Text -->
    <div class="confirmation-text">
      <h2>Are you sure want to {{ getActionTitle() }}</h2>
      <div class="document-info">
        <span class="document-name">{{ getDocumentName() }}</span>
        <span class="document-type">document {{ getActionPreposition() }}</span>
      </div>
      <div class="recipient-info">
        {{ getSelectedPeopleNames() }} ?
      </div>
    </div>
    
    <!-- Action Buttons -->
    <div class="action-buttons">
      <button mat-button class="cancel-btn" (click)="onCancel()">
        Cancel
      </button>
      <button mat-button 
              [color]="getConfirmButtonColor()" 
              class="share-btn" 
              (click)="onConfirm()">
        {{ getConfirmButtonText() }}
      </button>
    </div>
  </div>
</div>